import { EMPTY_OBJECT } from 'commons-ui';
import { UTILITIES_RESOURCES, URL } from '../../helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[UTILITIES_RESOURCES.assetUpload]}/create`
				});
			};
		case 'view':
			return () => {
				history.push({
					pathname: `${URL[UTILITIES_RESOURCES.assetUpload]}/view`,
					state: {
						rowData
					}
				});
			};
		default:
			return () => {
				return null;
			};
	}
};

export default {
	makeActionHandler
};
